import { h } from 'preact'
import { useMemo } from 'preact/hooks'
import PhoneInput from 'react-phone-number-input'
import randomString from '../../shared/random-string'
import cx from '../../shared/classes'
import { CountryCode } from 'libphonenumber-js/types'

import 'react-phone-number-input/style.css'
import * as style from './style.css'

type EventProps = {
    onChange?: (value: string) => void
    onCountryChange?: (countryCode: string) => void
}
type PhoneFieldProps = {
    error?: boolean | string
    placeholder?: string
    country?: CountryCode
    label?: string
    value?: string
    disabled?: boolean
    helperText?: string

    rules: { required: boolean }
}
type Props = EventProps & PhoneFieldProps

export const CustomPhoneInput = ({ placeholder, value, country, label, error, disabled, onChange, rules }: Props) => {
    const uniqId = useMemo(() => randomString(), [])

    const onChangeState = (value: string) => onChange && onChange(value)

    return (
        <div class={`${style.customField}`}>
            <div
                class={cx({
                    [style.field]: true,
                    [style.fieldDisabled]: disabled,
                })}
            >
                {Boolean(label) && (
                    <label htmlFor={uniqId} class={`${style.label}`}>
                        {label}
                    </label>
                )}

                <PhoneInput
                    class={style.phoneInputInput}
                    id={uniqId}
                    placeholder={placeholder}
                    initialValueFormat="national"
                    value={value}
                    defaultCountry={country}
                    country={country}
                    onChange={onChangeState}
                    rules={rules}
                />
                {Boolean(error) && <span class={style.errorMessage}>{error}</span>}
            </div>
        </div>
    )
}

export default CustomPhoneInput
